import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { localizeDate } from '@/utils/date';
import { getFileURL } from '@/utils/file-uploads';
import { get } from 'lodash';
export default {
  name: 'CoreVirtualDeviceDriverList',
  props: {
    hideHeader: {
      type: Boolean,
      default: false
    },
    smartGroupId: {
      type: Number,
      default: undefined
    }
  },
  data: function data() {
    return {
      selectedAccounts: [],
      accountFilterIsReady: false,
      cacheBuster: 0,
      itemsInDeletion: [],
      itemIdToBeDeleted: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['permissions', 'color'])), {}, {
    isVirtualDeviceDriverManager: function isVirtualDeviceDriverManager() {
      return this.permissions['DeviceDriver.manage'];
    },
    tableHeaders: function tableHeaders() {
      var _this = this;

      var headers = [{
        text: this.$i18n_t('DeviceDriver.list.table.headers.id'),
        value: 'id'
      }, {
        value: 'image',
        sortable: false,
        isAvatarImage: true
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.title'),
        value: 'title'
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.tenant'),
        value: 'Tenant.name'
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.parser'),
        value: 'parser'
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.createdAt'),
        value: 'createdAt'
      }];

      if (this.isVirtualDeviceDriverManager) {
        headers.push({
          text: this.$i18n_t('DeviceDriver.list.table.headers.actions'),
          isButtons: true,
          align: 'center',
          sortable: false,
          buttons: [{
            icon: 'fal fa-edit',
            color: this.color,
            onClick: function onClick(item) {
              _this.$router.push(_this.getSingleDriverUrl(item.id));
            }
          }, {
            icon: 'fal fa-trash-alt',
            color: this.color,
            onClick: function onClick(item) {
              _this.onDeleteClick(item);
            },
            loading: function loading(item) {
              return _this.itemsInDeletion.includes(item.id);
            }
          }]
        });
      }

      return headers;
    },
    headerButtons: function headerButtons() {
      return [{
        title: this.$i18n_t('DeviceDriver.list.header.buttons.copyPaste'),
        icon: 'fal fa-copy',
        action: 'copyPaste'
      }];
    }
  }),
  methods: {
    localizeDate: localizeDate,
    getSingleDriverUrl: function getSingleDriverUrl(id) {
      return "/virtual-device-drivers/".concat(id);
    },
    fetchItems: function () {
      var _fetchItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var _this2 = this;

        var search, page, perPage, sortBy, sortDirection, selectedAccounts, accountIds, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = options.search, page = options.page, perPage = options.perPage, sortBy = options.sortBy, sortDirection = options.sortDirection, selectedAccounts = options.selectedAccounts;
                accountIds = selectedAccounts.map(function (account) {
                  return account.id;
                });
                _context.next = 4;
                return ApiService.virtualDeviceDrivers.fetch({
                  limit: perPage,
                  offset: perPage * (page - 1),
                  sortBy: sortBy,
                  sortDesc: sortDirection === 'desc',
                  search: search,
                  accountIds: accountIds,
                  smartGroupId: this.smartGroupId
                });

              case 4:
                result = _context.sent;
                return _context.abrupt("return", {
                  items: result.deviceDrivers.map(function (item) {
                    var accountName = item.accountId;

                    if (item.account && item.account.name) {
                      accountName = item.Tenant.name;
                    }

                    return _objectSpread(_objectSpread({}, item), {}, {
                      name: accountName,
                      image: getFileURL(item.image, 2),
                      parser: _this2.parserListToTranslationKey(item.versions),
                      createdAt: _this2.localizeDate(item.createdAt)
                    });
                  }),
                  total: result.totalCount
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchItems(_x) {
        return _fetchItems.apply(this, arguments);
      }

      return fetchItems;
    }(),
    imageURL: function imageURL(image) {
      var host = process.env.VUE_APP_API_HOST;
      var imageUri = image;

      if (!imageUri) {
        return '';
      }

      if (!imageUri.startsWith('/')) {
        imageUri = "/".concat(imageUri);
      }

      return image ? "".concat(host, "/api/v1/upload/v2").concat(imageUri) : '';
    },
    parserListToTranslationKey: function parserListToTranslationKey(parsers) {
      var _this3 = this;

      var getDisplayStringForOne = function getDisplayStringForOne(parser) {
        return _this3.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes')[get(parser, 'parser.type', '__undefined__')] || _this3.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes.unset');
      };

      if (!parsers) {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes.unset');
      }

      return parsers.map(function (parser) {
        return getDisplayStringForOne(parser);
      }).join(', ');
    },
    onDeleteClick: function onDeleteClick(item) {
      this.itemIdToBeDeleted = item.id;
    },
    onDeleteItemConfirm: function () {
      var _onDeleteItemConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var itemId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                itemId = this.itemIdToBeDeleted;
                this.itemIdToBeDeleted = null;
                _context2.prev = 2;
                this.itemsInDeletion.push(itemId);
                _context2.next = 6;
                return ApiService.virtualDeviceDrivers.deleteOne(itemId);

              case 6:
                this.$snack(this.$i18n_t('DeviceDriver.list.deleteSuccess'), 'success');
                this.cacheBuster += 1;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                this.$snack(this.$i18n_t('DeviceDriver.list.deleteError'), 'error');

              case 13:
                _context2.prev = 13;
                this.itemsInDeletion = this.itemsInDeletion.filter(function (id) {
                  return id !== itemId;
                });
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 10, 13, 16]]);
      }));

      function onDeleteItemConfirm() {
        return _onDeleteItemConfirm.apply(this, arguments);
      }

      return onDeleteItemConfirm;
    }()
  }
};